import React from "react"
import { useKeenSlider } from "keen-slider/react"

export function KeenSliderWrapper(props) {
    const [sliderRef, slider] = useKeenSlider(props.options)
    React.useEffect(() => {
        if(slider && props.onInit)
            props.onInit(slider)
    }, [slider])

    return <div ref={sliderRef} className={"keen-slider" + (props.className ? " " + props.className : "")}>
        {props.children}
    </div>
}